import { Card, Row } from 'antd'
import React from 'react'
import Heading from '../../../component/common/Heading'
import CRUDComponent from '../../../component/common/CRUD-Component'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import { FOND_MODES } from '../../../util/functions'
import { useNavigate } from 'react-router-dom'

const ModeFeedback = () => {
    const navigate = useNavigate()
    return (
        <div className='my-5'>
            <Card>
                <Heading>Mode FeedBack</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: CONSTANTS.API.Mode_Feedback.getAll,
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `MF${data?.id.toString().padStart(7, "0")}`,
                                        modeD: FOND_MODES[data?.mode] || '-',
                                        options1: data?.options[0]?.toString(),
                                        options2: data?.options[1]?.toString(),
                                        options3: data?.options[2]?.toString(),
                                        options4: data?.options[3]?.toString(),
                                        optionsD: <>
                                            <div>Option 1 : <span className='font-semibold'> {data?.options[0]} </span></div>
                                            <div>Option 2 : <span className='font-semibold'> {data?.options[1]} </span></div>
                                            <div>Option 3 : <span className='font-semibold'> {data?.options[2]} </span></div>
                                            <div>Option 4 : <span className='font-semibold'> {data?.options[3]} </span></div>
                                        </>,
                                        view: {
                                            id: data?.id,
                                            onClick: () => {
                                                navigate(`/app/mode-feedback/${data?.id}`)
                                            }
                                        }

                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.MODE_FEEDBACK,
                        }}
                        CREATE={{
                            API: CONSTANTS.API.Mode_Feedback.add,
                            message: "Created Mode Feedback successfully",
                            modaltitle: "Add Mode Feedback",
                            modalFields: CONSTANTS.FORM_FIELD.MODE_FEEDBACK_MODAL,
                            payloadModifier: (res) => {
                                const optionsArr = [];
                                optionsArr.push(res.options1, res.options2, res.options3, res.options4)
                                return {
                                    question: res?.question,
                                    mode: res?.mode,
                                    options: optionsArr,
                                }
                            },
                        }}
                        UPDATE={{
                            API: CONSTANTS.API.Mode_Feedback.update,
                            message: "Edit Mode Feedback successfully",
                            modaltitle: "Edit Mode Feedback",
                            modalFields: CONSTANTS.FORM_FIELD.MODE_FEEDBACK_MODAL,
                            payloadModifier: (res) => {
                                const optionsArr = [];
                                optionsArr.push(res.options1 ?? res?.options[0], res.options2 ?? res?.options[1], res.options3 ?? res?.options[2], res.options4 ?? res?.options[3])
                                return {
                                    question: res?.question,
                                    mode: res?.mode,
                                    options: optionsArr,
                                }
                            },
                        }}
                        DELETE={{
                            API: CONSTANTS.API.Mode_Feedback.delete,
                            message: "Deleted Successfully",
                        }}
                        isSearch={true}
                        FILTERSORTKEY={
                            { "modeD": 'mode' }
                        }
                    />
                </Row>
            </Card>
        </div>
    )
}

export default ModeFeedback